var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangTh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 182 182",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-199 -999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 1e3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.08 150c-16.48 18.412-40.428 30-67.083 30-26.655 0-50.604-11.588-67.083-30zm0-120c-16.48-18.412-40.428-30-67.083-30-26.655 0-50.604 11.588-67.083 30z",
    fill: "#ca4638"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1 0 180)",
    d: "m157.08 150c14.251-15.923 22.917-36.949 22.917-60 0-23.051-8.6656-44.077-22.917-60h-134.17c-14.251 15.923-22.917 36.949-22.917 60 0 23.051 8.6656 44.077 22.917 60z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.88 120c3.3165-9.3834 5.1212-19.481 5.1212-30s-1.8046-20.617-5.1212-30l-169.76 4e-7c-3.3165 9.3834-5.1212 19.481-5.1212 30s1.8046 20.617 5.1212 30h169.76z",
    fill: "#346da6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangTh);
export default __webpack_public_path__ + "static/media/lang-th.e23216841cdfd3a427d6514152dabdf0.svg";
export { ForwardRef as ReactComponent };